import { myFetch, HttpMethod } from './baseService';

export interface ReservaZonaComun {
  rzc_codigo: string;
  rzc_ruta_foto_principal?: string;
  rzc_zona_comun_turnos_para_reserva?: number;
  rzc_zona_comun: string;
  rzc_zona_comun_nombre: string;
  rzc_apartamento: string;
  rzc_apartamento_nombre: string;
  rzc_nombre_de_reservador: string;
  rzc_estatus: string;
  rzc_estatus_nombre: string;
  rzc_fecha_separacion: string;
  rzc_dia_reservado: string;
  rzc_dia_reservado_nombre: string;
  rzc_hora_inicio_reservada: string;
  rzc_hora_final_reservada: string;
  rzc_valor: number;
}

export interface ObtenerReservasRequest {
  "unidad residencial codigo": string;
  "zona comun codigo": string;
  "apartamento codigo": string;
  "fecha (dd/mm/aaaa)": string;
  "reserva zona comun codigo"?: string;
}

export interface AprobarReservaRequest {
  reserva_zona_comun_codigo: string;
}

export interface NoAprobarReservaRequest {
  reserva_zona_comun_codigo: string;
}

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

export const obtenerReservasZonaComun = async (
  payload: ObtenerReservasRequest
): Promise<ApiEnvelope<ReservaZonaComun[]>> => {
  const envelope = await myFetch<ApiEnvelope<ReservaZonaComun[]>>(
    'reserva_zona_comun/ObtenerTodos',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

export const aprobarReservaZonaComun = async (
  payload: AprobarReservaRequest
): Promise<ApiEnvelope<ReservaZonaComun[]>> => {
  const envelope = await myFetch<ApiEnvelope<ReservaZonaComun[]>>(
    'reserva_zona_comun/Aprobar',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

export const noAprobarReservaZonaComun = async (
  payload: NoAprobarReservaRequest
): Promise<ApiEnvelope<ReservaZonaComun[]>> => {
  const envelope = await myFetch<ApiEnvelope<ReservaZonaComun[]>>(
    'reserva_zona_comun/NoAprobar',
    HttpMethod.POST,
    payload
  );
  return envelope;
};
